/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';

const cardAudioBehavior = createBehavior(
  'card-audio',
  {
    bindUI() {
      this.ui = {};
      this.ui.btn = this.getChild('btn');
    },
    bindEvents() {
      this.ui.btn.addEventListener('click', this.clickHandler, false);
    },
    openModal() {
      const audios = [];
      let currentIndex = 0;

      const block = this.node.closest('.block-flv-play-audios');
      if (block) {
        const siblings = block.querySelectorAll('[data-behavior="card-audio"]');
        siblings.forEach((sibling, i) => {
          try {
            const audioData = JSON.parse(sibling.dataset.audio);
            audios.push(audioData);
            if (sibling === this.node) currentIndex = i;
          } catch (err) {}
        });
      }

      if (!audios.length) {
        try {
          audios.push(JSON.parse(this.node.dataset.audio));
        } catch (err) {
          return;
        }
      }

      document.dispatchEvent(
        new CustomEvent('card-audio:open', {
          detail: { audios, index: currentIndex },
        }),
      );
    },
    clickHandler() {
      this.openModal();
    },
  },
  {
    init() {
      this.bindUI();
      this.bindEvents();
    },
    destroy() {},
  },
);

export default cardAudioBehavior;
